import { DataUtil } from "../util/data.util";
import { NumeroUtil } from "../util/numero.util";
import { StringUtil } from "../util/string.util";
import { NaturezaAto } from "./natureza-ato.model";
import { Orgao } from "./orgao.model";
import { Segmento } from "./segmento.model";
import { SituacaoDou } from "./situacao-dou.model";
import { TipoAto } from "./tipo-ato.model";

export class Ato {
    idAto?: number;
    tipoAto: TipoAto;
    numeroAto: string;
    dataAto?: Date = undefined;
    dataPublicacao: Date;
    situacaoDOU: SituacaoDou;
    sofreuAnotacaoExclusao: boolean;
    republicacao: boolean;
    idAtoRepublicado?: number;
    numeroPagina: number | undefined;
    usuarioBRS: string;
    dataBRS: string;
    importBRS: string;
    situacaoBRS: string;
    dataVigenciaInicio: Date;
    dataVigenciaFim?: Date;
    publicado = false;
    privado: boolean;
    idMunicipio: number;
    naturezaAto: NaturezaAto;
    exibirVisoes = '1111';
    flags: string;
    idLocalPublicacao = 1;
    internet = false;
    secao: string;
    textoLivre: string;
    observacao = '';
    dataNotificacao: Date;
    idDetalheInclusaoManual: number;
    situacaoProcessamentoAto: string;
    orgaos: Orgao[] = [];
    orgaoResponsavel: Orgao;
    segmentos: Segmento[] = [];
    orgaosStr?: string;

    epigrafeCompleta: string;
    dadosPublicacao: string;
    dadosPublicacaoRepetida: string;
    idAtoAnteriorPublicacaoRepetida: number;

    static getFunctionSortBy(campo: string): (a1: Ato, a2: Ato) => number {
        if (campo == 'idAto')
            return (a1: Ato, a2: Ato) => NumeroUtil.sort(a1.idAto, a2.idAto);

        if (campo == 'orgaos')
            return (a1: Ato, a2: Ato) => StringUtil.sort(a1.orgaosStr, a2.orgaosStr);

        if (campo == 'numeroAto') {
            return (a1: Ato, a2: Ato) => {
                if (isNaN(parseInt(a1.numeroAto)) || isNaN(parseInt(a2.numeroAto))
                        || parseInt(a1.numeroAto) == parseInt(a2.numeroAto)) {
                    return StringUtil.sort(a1.numeroAto, a2.numeroAto);
                }
                return NumeroUtil.sort(parseInt(a1.numeroAto), parseInt(a2.numeroAto));
            }
        }

        if (campo == 'tipoAto')
            return (a1: Ato, a2: Ato) => StringUtil.sort(a1.tipoAto.siglaTipoAto, a2.tipoAto.siglaTipoAto);

        if (campo == 'dataPublicacao')
            return (a1: Ato, a2: Ato) => DataUtil.compareDate(a1.dataPublicacao, a2.dataPublicacao);

        if (campo == 'dataAto')
            return (a1: Ato, a2: Ato) => DataUtil.compareDate(a1.dataAto, a2.dataAto);

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return (a1: Ato, a2: Ato) => 0;
    }
}